import { Component, EventEmitter, OnInit, Output, Input, SimpleChanges, ChangeDetectorRef } from '@angular/core';
import { AttendanceService } from '../../services/attendance.service';
import { LearnerService } from '../../services/learner.service';
import { saveAs } from "file-saver";
import { Subject } from 'rxjs';
import { findIndex, map, takeUntil } from 'rxjs/operators';
import differenceBy from 'lodash/differenceBy'
import * as _ from 'lodash';
import { UtilityService } from 'src/app/services/utility.service';
import { AllotmentConfirmationComponent } from 'src/app/courses/assignment-status/allotment-confirmation/allotment-confirmation.component';
import { element } from 'protractor';
@Component({
  selector: 'app-attendance-row',
  templateUrl: './attendance-row.component.html',
  styleUrls: ['./attendance-row.component.scss']
})
export class AttendanceRowComponent implements OnInit {
  user: any;
  currentUser: any;
  logToUpdate: any = [];
  hoverIndex: any;
  pdfDownload: any;
  totalCounts: any = [1];

  attendanceZero: any;
  attendanceOne: any;
  currentJob
  jobId
  @Input('attendance') attendance
  @Input('clearData') clearData
  @Input('isPdfDownload') isPdfDownload
  @Input('singleJob') job
  @Output() learnerObj: EventEmitter<any> = new EventEmitter<any>();
  @Output() updateLogs: EventEmitter<any> = new EventEmitter<any>();
  @Output() finalArray: EventEmitter<any> = new EventEmitter<any>();
  courseMetaId: any;
  courseId: any;
  isAdmin: boolean = false
  private learnerRemove: Subject<any> = new Subject<any>();
  private addLearnerSubscription: Subject<any> = new Subject<any>();


  constructor(
    public _change: ChangeDetectorRef,
    public _utilityServices: UtilityService,
    public _attendanceService: AttendanceService,
    private _learnerService: LearnerService,
    // public _change: ChangeDetectorRef
  ) {
    this._learnerService.newLearnerObservable()
      .pipe(
        takeUntil(this.addLearnerSubscription)
      )
      .subscribe((newLearner) => {
        console.log("who is new learner", newLearner);
        console.log("current job value when new learner added", this.currentJob);
        console.log("what is the final array to be store", this.attendance);

        // let learnerArray = this.allLearners;
        newLearner.learner['checked'] = false
        let obj = {
          _id: newLearner.learner._id,
          name: newLearner.learner.name,
          duration: this.currentJob.course.duration,
          attendance: []
        }
        let coursejobDatesList = this.currentJob.course.courseMetaId.jobDatesList

        for (let i = 0; i < coursejobDatesList.length; i++) {
          obj.attendance.push({ day: coursejobDatesList[i].day, amStatus: "unmark", pmStatus: "unmark", amTooltip: "Unmark", pmTooltip: "Unmark", attendanceAmHours: '00:00', attendancePmHours: '00:00', date: coursejobDatesList[i].date, attendanceId: coursejobDatesList[i]._id })

          // }
        }
        this.attendance.push(obj)
        console.log("finall attedence data here ==>", this.attendance)
        this._change.detectChanges();
      });


    this._learnerService.removeLearnerObservable()
      .pipe(
        takeUntil(this.learnerRemove)
      )
      .subscribe((learner) => {
        console.log("when learner remove from job", learner);
        let index = this.attendance.findIndex(x => x._id === learner._id);
        if (index > -1) {
          this.attendance.splice(index, 1)
          console.log("after learner remove in assignment page", this.attendance);
          // this.updateData(this.learners)
        }
      })

    /*this._attendanceService.isClearCell().subscribe((value) =>{
      this.logToUpdate = [];
    });*/
  }

  ngOnDestroy() {
    console.log("HELLO HERE IS ON DESTROY", this.learnerRemove.closed)
    this.learnerRemove.next();
    this.learnerRemove.complete();
    this.addLearnerSubscription.next();
    this.addLearnerSubscription.complete();

    console.log("this.learnerRemove!!!", (!this.learnerRemove.closed))
  }


  ngOnInit() {
    this.currentUser = JSON.parse(localStorage.currentUser);
    this.user = JSON.parse(localStorage.getItem('userRoles'))
    this._change.detectChanges();
    if (this.user.isAdmin) this.isAdmin = true
  }

  ngOnChanges(changes: SimpleChanges): void {
    //console.group("ngOnChanges in attenadance-row", changes.attendancel)
    // console.log("Changes in attenadance-row", changes.job.currentValue);

    if (changes && changes.attendance) {
      this.attendance = changes.attendance.currentValue
      console.log("this.attendance---->", this.attendance);
      this.finalArray.emit(this.attendance);
    }



    if (changes.clearData && changes.clearData.currentValue) {
      this.logToUpdate = [];
    }

    if (changes.isPdfDownload && changes.isPdfDownload.currentValue) {
      console.log("Is PDF Download Truee");
      this.attendanceZero = JSON.parse(JSON.stringify(this.attendance));
      this.attendanceOne = JSON.parse(JSON.stringify(this.attendance));
      this.pdfDownload = changes.isPdfDownload.currentValue;
      /*_.forEach(this.attendanceZero, (singleLearner) => {
        singleLearner.attendance.splice(11, 21)
      });

      _.forEach(this.attendanceOne, (singleLearner) => {
        singleLearner.attendance.splice(0, 10)
      });*/


    }
    if (changes.job && changes.job.currentValue) {
      this.currentJob = changes.job.currentValue
      console.log("current job value", this.currentJob);
      this.jobId = this.currentJob._id
      this.courseMetaId = this.currentJob.course.courseMetaId._id
      this.courseId = this.currentJob.course._id
      console.log("this.courseMetaId--->", this.courseMetaId);

    }
    // console.groupEnd();
    this._change.detectChanges();

  }

  updateDate(event) {
    console.log("event in attendance-row = ", event);
    // let filterdArray = []

    // filterdArray = event.filter(item => item.isDelete === false)

    // for (let i = 0; i < event.length; i++) {
    //   if (event[i].isDelete == true) { }
    //   else {
    //     filterdArray.push(event[i])
    //   }
    // }
    // console.log("filterdArray", filterdArray);
    // let tempArray = []
    // for (let i = 0; i < this.attendance.length; i++) {
    //   for (let j = 0; j < filterdArray.length; j++) {
    //     for (let k = 0; k < this.attendance[i].attendance.length; k++) {
    //       if (filterdArray[j]._id == this.attendance[i].attendance[k].attendanceId) {
    //         this.attendance[i].attendance[k].day = j + 1
    //         if (filterdArray[j].date)
    //           this.attendance[i].attendance[k].date = filterdArray[j].date
    //         tempArray.push(this.attendance[i].attendance[k])
    //       }
    //     }
    //   }
    //   console.log("tempArray------>", tempArray)
    //   this.attendance[i].attendance = tempArray
    //   this.attendance[i].jobDatesList.jobDatesList = event
    //   tempArray = []
    //   // this.learnerObj.emit(this.attendance[i].attendance);
    // }
    // if (this.attendance[0].jobDatesList.jobDatesList.includes(event._id)) {
    //   this.attendance[0].jobDatesList.jobDatesList.date = event.date
    //   this.attendance[0].jobDatesList.jobDatesList.courseDetails = event.courseDetails
    // }
    this.attendance = event
    // this.learnerObj.emit(this.attendance);
    console.log("this.attendance in attendance-row = ", this.attendance);
  }

  updateLog(event) {
    // console.group("updateLog");
    // console.log("event in row component ===>", event);
    switch (event.log.isSelected) {
      case true:
        // this.logToUpdate = event.lo
        this.addDatatoUpdateLogArray(event.log)
        break;

      case false:

        this.removeDataFromUpdateLogArray(event.log)

        break;

      default:
        // code...
        break;
    }
    // const dataIndex = _.findLastIndex(users, function(o) { return o.user == 'pebbles'; });
    //console.groupEnd();
  }

  addDatatoUpdateLogArray(log) {
    console.group("addDatatoUpdateLogArray", log);
    console.log("this is another", this.logToUpdate);

    const recordIndex = _.findLastIndex(this.logToUpdate, (o) => { return o.learnerId == log.learnerId; })
    // console.log("recordIndex",recordIndex);

    if (recordIndex != -1) {
      const attendanceIndex = _.findLastIndex(this.logToUpdate[recordIndex].attendance, (o) => { return o.singleJobDateId == log.attendance.singleJobDateId; });
      // console.log("attendanceIndex",attendanceIndex);

      if (attendanceIndex != -1) this.logToUpdate[recordIndex].attendance[attendanceIndex][log.status] = log.attendance[log.status];
      else this.logToUpdate[recordIndex].attendance.push(log.attendance);

      this.learnerObj.emit(this.logToUpdate);
      // this.updateLogs.emit(this.logToUpdate);
    }
    else {
      const obj = {
        learnerId: log.learnerId,
        attendance: [
          log.attendance
        ]
      }
      this.logToUpdate.push(obj);
      // this.logToUpdate = obj
      this.learnerObj.emit(this.logToUpdate);
      // this.updateLogs.emit(this.logToUpdate);
    }

    console.log("this.logToUpdate record When added ==>", this.logToUpdate)
    console.groupEnd();
  }

  removeDataFromUpdateLogArray(log) {
    // console.group("removeDataFromUpdateLogArray ");
    //console.log(log);

    const recordIndex = _.findLastIndex(this.logToUpdate, (o) => { return o.learnerId == log.learnerId; })
    // console.log("recordIndex",recordIndex);

    const attendanceIndex = _.findLastIndex(this.logToUpdate[recordIndex].attendance, (o) => { return o.day == log.attendance.day; });
    // console.log("attendanceIndex",attendanceIndex);

    delete this.logToUpdate[recordIndex].attendance[attendanceIndex][log.status]

    if (!this.logToUpdate[recordIndex].attendance[attendanceIndex]["amStatus"] && !this.logToUpdate[recordIndex].attendance[attendanceIndex]["pmStatus"])
      this.logToUpdate[recordIndex].attendance.splice(attendanceIndex, 1);

    if (!this.logToUpdate[recordIndex].attendance.length) {
      this.logToUpdate.splice(recordIndex, 1);
    }

    // this.logToUpdate.push(obj);
    this.learnerObj.emit(this.logToUpdate);
    // this.updateLogs.emit(this.logToUpdate);
    // console.log("this.logToUpdate record When removed ==>", this.logToUpdate);
    //console.groupEnd();
  }

  updatesLog(event) {
    console.log("event 2");
    this.updateLogs.emit(event);
    console.log("array to be send from attendance-day-type", this.updateLogs);
  }



  learnerIndex(i) {
    this.hoverIndex = i;
  }

  learnerIndexChanged(i) {
    this.hoverIndex = -1
  }

  addMoreDay() {
    console.log("plus btn clicked")
    let data = {
      courseMetaId: this.courseMetaId,
      courseId: this.courseId,
      jobDatesList: this.attendance[0].jobDatesList.jobDatesList,
      register: true,
      scheduleDates: this.currentJob.scheduleDates,
      jobId: this.jobId,
      unitList: false,
      isAdd: true
    }
    console.log("data pass in model", data);
    this._utilityServices.commonDialogBoxOpen(AllotmentConfirmationComponent, data)
      .afterClosed().subscribe(res => {
        console.log("updated data get", res);
        if (res == undefined) return
        else {
          // let length = res.jobDatesList.length
          // console.log("length===>", length);
          // const differences = differenceBy(res.jobDatesList, this.attendance[0].jobDatesList.jobDatesList, '_id')
          // console.log("diff--------->", differences);
          // let newObj = {
          //   amStatus: "unmark",
          //   pmStatus: "unmark",
          //   date: differences[0].date,
          //   day: differences[0].day,
          //   attendanceId: differences[0]._id
          // }
          let tempDate = res.attendance[0].attendance.findIndex((x) => x.date == res.date)
          if (tempDate != -1) {
            res.attendance[0].attendance[tempDate]['newDay'] = true
          }
          this.attendance = res.attendance
          console.log("Check existing data of dates add", this.attendance);

          // let filterdArray = []
          // for (let i = 0; i < res.jobDatesList.length; i++) {
          //   if (res.jobDatesList[i].isDelete == false)
          //     filterdArray.push(res.jobDatesList[i])
          // }
          // console.log("filterdArray", filterdArray);

          // let tempArray = []
          // for (let i = 0; i < this.attendance.length; i++) {
          //   this.attendance[i].attendance.splice(newObj.day - 1, 0, newObj);
          //   for (let j = 0; j < filterdArray.length; j++) {
          //     for (let k = 0; k < this.attendance[i].attendance.length; k++) {
          //       if (filterdArray[j]._id == this.attendance[i].attendance[k].attendanceId) {
          //         this.attendance[i].attendance[k].day = j + 1
          //         if (filterdArray[j].date)
          //           this.attendance[i].attendance[k].date = filterdArray[j].date
          //         tempArray.push(this.attendance[i].attendance[k])
          //       }
          //     }
          //   }
          //   console.log("tempArray------>", tempArray)
          //   this.attendance[i].attendance = tempArray
          //   this.attendance[i].jobDatesList.jobDatesList = res.jobDatesList
          //   tempArray = []
          // }
          // this.learnerObj.emit(this.attendance);
          // console.log('res added in this.attendance : ', this.attendance)
          this.finalArray.emit(this.attendance);
          this._utilityServices.handleSnackBar({ msg: "Day added successfully!", button: "Ok" })
          this._change.detectChanges()
        }
      }, (error) => {
        console.log('edit time some error occure!!', error)
        this._utilityServices.handleSnackBar({ msg: "Something went wrong!", button: "Ok" })
      })
  }






}
